/**
 * Where an old link lands.
 *
 * Two kinds arrive: the consumer app's /admin?tab=growth&user=<id> (the Slack
 * growth alerts and the daily digest link there, and www.posture.vision/admin
 * now redirects here with the query string intact), and this app's own old
 * paths (/dashboard, /users/<id>, /tickets, /admins, /system-health). Both
 * map onto the five pages so no bookmark or Slack line goes dead.
 */
export const legacyTarget = (pathname: string, search: string): string => {
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
  const tab = params.get('tab');
  const user = params.get('user');
  params.delete('tab');
  params.delete('user');

  const path = pathname.replace(/\/+$/, '') || '/';
  let target = '/';
  if (path === '/admin' || path === '/dashboard' || path.startsWith('/dashboard/')) {
    if (tab === 'growth' || tab === 'journal') target = '/people';
    else if (tab === 'applications') target = '/people';
    else if (tab === 'demand') target = '/product';
    else target = '/';
    if (tab === 'journal' && user) params.set('journal', '1');
    if (tab === 'applications') params.set('section', 'applications');
  } else if (path === '/users') {
    target = '/people';
  } else if (path.startsWith('/users/')) {
    target = `/people/${encodeURIComponent(decodeURIComponent(path.slice('/users/'.length).split('/')[0]))}`;
  } else if (path === '/tickets' || path.startsWith('/tickets/')) {
    target = '/';
  } else if (path === '/admins' || path === '/audit-log') {
    target = '/settings';
  } else if (path === '/system-health') {
    target = '/system';
  } else if (path === '/providers' || path.startsWith('/providers/') || path === '/exercise-requests') {
    target = '/product';
  } else if (path === '/provider-applications' || path.startsWith('/provider-applications/')) {
    target = '/people';
    params.set('section', 'applications');
  }
  if (user && !params.has('user')) params.set('user', user);
  const qs = params.toString();
  return qs ? `${target}?${qs}` : target;
};
